/**
 * defa.collections.alarmswitchs
 * A Collection of AlarmSwitchs
 * @version 1.2.0
 */
import AlarmSwitch from './model-alarm-switch';

const AlarmSwitchs = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : AlarmSwitch,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

} );


export default AlarmSwitchs